import { compose, lifecycle } from 'recompose';
import { connect } from 'react-redux';
import _ from 'lodash';

import SportsApiHome from '../components/SportsApiHome';
import { ROLES } from '../../../../consts';

const mapStateToProps = state => {
  return {
    auth: state.auth,
    roles: _.get(state, 'auth.currentGroup.myRoles', 'default'),
  };
};

const enhance = compose(
  connect(mapStateToProps),
  lifecycle({
    componentDidMount() {},
    componentWillUnmount() {},
    componentDidUpdate() {
      if (
        !this.props.roles.includes(ROLES.SPORTRADAR) &&
        !this.props.roles.includes(ROLES.SUPERADMIN)
      ) {
        this.props.history.push('/dashboard');
      }
    },
  })
);

export default enhance(SportsApiHome);
